import { Amplify } from 'aws-amplify';

Amplify.configure({
    API: {
        REST: {
            DigitalMemorials: {
                endpoint: "https://56qhanigp3.execute-api.eu-west-1.amazonaws.com/dm"
            }
        }
    }
}); 